import type { DataSourceDataParams } from "@infinite-table/infinite-react";
import type { ScreenerData } from "epsm-api-types/models";
import { type Dispatch, type SetStateAction, useCallback } from "react";

export const useDataParamsChange = (
	setDataParams: Dispatch<
		SetStateAction<Partial<DataSourceDataParams<ScreenerData>>>
	>,
) => {
	return useCallback(
		(dataParams: DataSourceDataParams<ScreenerData>) => {
			const params = {
				groupBy: dataParams.groupBy,
				sortInfo: dataParams.sortInfo,
				filterValue: dataParams.filterValue,
				livePaginationCursor: dataParams.livePaginationCursor,
			};

			setDataParams(params);
		},
		[setDataParams],
	);
};
